import styled from 'styled-components'
import { breakpoints } from '../../../../../constants'

export const StyledMyPlan = styled.div`
	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}

	.plan {
		display: flex;
		flex-direction: column;
		align-items: flex-start;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			flex-direction: row;
			align-items: center;
		}
	}

	.plan-info {
		font-size: 18px;
		margin-top: 15px;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			margin-top: 0;
			margin-left: 30px;
			display: flex;
			flex-direction: column;
		}
	}

	button {
		margin-top: 15px;
		padding: 1.5rem;
	}
`
